import nav from './nav.json'
import login from './login.json'
import dashboard from './dashboard.json'
import profile from './profile.json'
import balance from './balance.json'
import green from './green.json'

export default {
  nav,
  login,
  dashboard,
  profile,
  balance,
  green
}
